/* Slide counter for the product gallery ("1 / 7").

   The index and the total both come from the carousel's own public getters, the
   same source the dash indicators read, so the two controls can never disagree
   about which slide is showing. */

class ProductGalleryCounter extends HTMLElement {
  connectedCallback() {
    this._carousel = document.getElementById(this.getAttribute("aria-controls"));
    this._current = this.querySelector("[data-gallery-counter-current]");
    this._total = this.querySelector("[data-gallery-counter-total]");

    if (!this._carousel || !this._current || !this._total) {
      return;
    }

    this._abortController = new AbortController();
    this._render = this._render.bind(this);

    // carousel:change covers swiping and programmatic selection; carousel:filter
    // fires when a variant hides part of the media set.
    this._carousel.addEventListener("carousel:change", this._render, { signal: this._abortController.signal });
    this._carousel.addEventListener("carousel:filter", this._render, { signal: this._abortController.signal });

    // The carousel reports visibility from layout, so wait for the first frame.
    requestAnimationFrame(this._render);
  }

  disconnectedCallback() {
    this._abortController?.abort();
  }

  _render() {
    const total = this._carousel.visibleItems?.length ?? 0;

    // Nothing to count through when there is a single slide left.
    if (total < 2) {
      this.hidden = true;
      return;
    }

    const position = this._carousel.selectedIndexAmongVisible + 1;

    this.hidden = false;
    this._total.textContent = total;
    this._current.textContent = Math.min(Math.max(position, 1), total);
  }
}

if (!window.customElements.get("product-gallery-counter")) {
  window.customElements.define("product-gallery-counter", ProductGalleryCounter);
}
